import React from 'react';
import styled from 'styled-components';

const StyledSvg = styled.svg`
  width: 40px;
  height: 40px;
  margin-right: 10px;

  .dot {
    fill: #4CAF50;
    transform-origin: center;
    animation: pulse 2s ease-in-out infinite;
  }

  .wave1 {
    stroke: #4CAF50;
    stroke-width: 2;
    fill: none;
    transform-origin: center;
    animation: wave 2s ease-in-out infinite;
  }

  .wave2 {
    stroke: #FFA726;
    stroke-width: 2;
    fill: none;
    transform-origin: center;
    animation: wave 2s ease-in-out infinite;
    animation-delay: -0.5s;
  }

  .wave3 {
    stroke: #f44336;
    stroke-width: 2;
    fill: none;
    transform-origin: center;
    animation: wave 2s ease-in-out infinite;
    animation-delay: -1s;
  }

  @keyframes pulse {
    0%, 100% {
      transform: scale(0.8);
      opacity: 1;
    }
    50% {
      transform: scale(1);
      opacity: 0.8;
    }
  }

  @keyframes wave {
    0% {
      transform: scale(1);
      opacity: 0.8;
    }
    100% {
      transform: scale(2);
      opacity: 0;
    }
  }
`;

const LiveDot: React.FC = () => {
  return (
    <StyledSvg viewBox="0 0 24 24">
      <circle className="wave1" cx="12" cy="12" r="5" />
      <circle className="wave2" cx="12" cy="12" r="5" />
      <circle className="wave3" cx="12" cy="12" r="5" />
      <circle className="dot" cx="12" cy="12" r="2.5" />
    </StyledSvg>
  );
};

export default LiveDot; 